import {Form as FormBase, FormProvider} from '@yandex-delivery/nlf-form/v2'
import React from 'react'
import type {Poll} from 'src/api'

import {useDefaultValues} from './Form.hooks'
import type {FormType} from './Form.types'

type FormWrapperProps = React.PropsWithChildren<Record<never, never>>
function FormWrapper({children}: FormWrapperProps): React.ReactElement<FormWrapperProps> {
  return <FormBase>{children}</FormBase>
}

type FormProps = React.PropsWithChildren<{poll: Poll}>
export function Form({children, poll}: FormProps): React.ReactElement<FormProps> {
  const defaultValues = useDefaultValues(poll)

  return (
    <FormProvider<FormType> defaultValues={defaultValues}>
      <FormWrapper>{children}</FormWrapper>
    </FormProvider>
  )
}
